import React, { Key, useState } from "react"
import { Button, Flex } from "antd"
import { Space } from "antd"
import MatchTypesSelect from "./MatchTypeSelect"
import NonManagedCampaign from "../../../components/NonManagedCampaign"
import CampaignActions from "./CampaignActions"
import { matchTypesEnum } from "../../../types/customers"
import CustomFilters from "./CustomFilters"
import { ICampaignDataColumns } from "../types/table"
import { setStateType } from "../../../types/setStateType"

interface ISettings {
  campaignData: any[]
  setExpandedRowCampaignIds: (campaignId: Key[]) => void
  setMatchType: setStateType<matchTypesEnum>
  matchType: matchTypesEnum
  selectedRowCampaignIds: Key[]
  setSelectedRowCampaignIds: setStateType<Key[]>
  selectedTargetRowCampaignIds: Key[]
  setCampaigns: setStateType<ICampaignDataColumns[]>
  campaigns: ICampaignDataColumns[]
}

const Settings: React.FC<ISettings> = ({
  campaignData,
  setExpandedRowCampaignIds,
  setMatchType,
  matchType,
  selectedRowCampaignIds,
  setSelectedRowCampaignIds,
  selectedTargetRowCampaignIds,
  setCampaigns,
  campaigns,
}) => {
  const [isExpand, setIsExpand] = useState<boolean>(true)

  const onClick = () => {
    if (isExpand) {
      const expandCampaignCampaignIds: string[] = []
      campaignData.map((campaign) => {
        expandCampaignCampaignIds.push(campaign.campaignId)
      })
      setExpandedRowCampaignIds(expandCampaignCampaignIds)
    } else {
      setExpandedRowCampaignIds([])
    }

    setIsExpand((prevIsExpand) => !prevIsExpand)
  }

  return (
    <Flex justify="space-between" align="flex-start">
      <Space align="start">
        <Button onClick={onClick}>{isExpand ? "Expand All" : "Collapse All"}</Button>
        <NonManagedCampaign />
        <MatchTypesSelect setMatchType={setMatchType} matchType={matchType} />
      </Space>
      <Space direction="vertical" align="end">
        <CustomFilters />
        <CampaignActions
          selectedRowCampaignIds={selectedRowCampaignIds}
          setSelectedRowCampaignIds={setSelectedRowCampaignIds}
          selectedTargetRowCampaignIds={selectedTargetRowCampaignIds}
          setCampaigns={setCampaigns}
          campaigns={campaigns}
        />
      </Space>
    </Flex>
  )
}

export default Settings
